module.exports = {"apiVersion":{"major":10,"minor":2},"itemDataVersion":{"major":0,"minor":1}}


/*****************
 ** WEBPACK FOOTER
 ** ./src/version.json
 ** module id = 50
 ** module chunks = 0 2
 **/